export default __webpack_public_path__ + "static/media/roboto-latin-700italic.9360531f.woff";